// Group GROUP 14. Register and Formality
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group14Data = {
  "id": "group_14",
  "title": {
    "tc": "風格與正式度",
    "sc": "风格与正式度",
    "en": "Register and Formality"
  },
  "subtitle": {
    "tc": "Register and Formality",
    "sc": "Register and Formality",
    "en": "Register and Formality"
  },
  "icon": "📚",
  "difficulty": "advanced",
  "color": "from-emerald-500 to-emerald-600",
  "topics": [
    {
      "id": "preposition_stranding",
      "title": {
        "tc": "介詞前置",
        "sc": "介词前置",
        "en": "Preposition Stranding vs Pied-piping (Formal)"
      },
      "description": {
        "tc": "學習正式語體中的介詞前置用法",
        "sc": "学习正式语体中的介词前置用法",
        "en": "Learn formal preposition pied-piping usage"
      },
      "icon": "📝",
      "difficulty": "advanced",
      "examples": [
        {
          "id": "prep_formal_1",
          "sentence": "The person to whom I spoke is here.",
          "analysis": "The person (S) <to whom> [I spoke] is (V) here (M).",
          "translation": {
            "tc": "我與之交談的那個人在這裡。",
            "sc": "我与之交谈的那个人在这里。",
            "en": "The person to whom I spoke is here."
          }
        },
        {
          "id": "prep_formal_2",
          "sentence": "The topic about which we talked is complex.",
          "analysis": "The topic (S) <about which> [we talked] is (V) complex (C).",
          "translation": {
            "tc": "我們談論的話題很複雜。",
            "sc": "我们谈论的话题很复杂。",
            "en": "The topic about which we talked is complex."
          }
        },
        {
          "id": "prep_formal_3",
          "sentence": "The reason for which they left is unclear.",
          "analysis": "The reason (S) <for which> [they left] is (V) unclear (C).",
          "translation": {
            "tc": "他們離開的原因不清楚。",
            "sc": "他们离开的原因不清楚。",
            "en": "The reason for which they left is unclear."
          }
        },
        {
          "id": "prep_formal_4",
          "sentence": "The city in which she lives is safe.",
          "analysis": "The city (S) <in which> [she lives] is (V) safe (C).",
          "translation": {
            "tc": "她居住的城市很安全。",
            "sc": "她居住的城市很安全。",
            "en": "The city in which she lives is safe."
          }
        },
        {
          "id": "prep_formal_5",
          "sentence": "The rule under which we operate is strict.",
          "analysis": "The rule (S) <under which> [we operate] is (V) strict (C).",
          "translation": {
            "tc": "我們運作所依據的規則很嚴格。",
            "sc": "我们运作所依据的规则很严格。",
            "en": "The rule under which we operate is strict."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：正式文用介詞前置（pied-piping）；口語允許句尾介詞。",
        "sc": "要点：正式文用介词前置（pied-piping）；口语允许句尾介词。",
        "en": "Key points: formal writing uses preposition pied-piping; speech allows sentence-final prepositions."
      }
    }
  ]
};
